import { Card } from '@/shared/ui/Card'
import { PageHeader, Screen } from '@/shared/ui/Layout'
import { ProgressBar } from '@/shared/ui/ProgressBar'

import { MedalThumb } from './components/MedalThumb'
import { useMedalsCollection } from './hooks/useMedalsCollection'

const MedalsSkeleton = () => (
  <div className="flex flex-col gap-3" aria-busy>
    <div className="h-[88px] animate-pulse rounded-2xl bg-gray-200/80" />
    <div className="grid grid-cols-3 gap-3">
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="aspect-square animate-pulse rounded-2xl bg-gray-200/80"
        />
      ))}
    </div>
  </div>
)

export const DigitalProductMedals = () => {
  const { medals, unlockedCount, total, percent, isEmpty, isLoading } =
    useMedalsCollection()

  return (
    <Screen>
      <Screen.Context>
        <PageHeader title="Medalhas" />

        {!isLoading && !isEmpty && (
          <Card className="shadow-sm">
            <Card.Body className="flex flex-col gap-1.5 px-4 py-3">
              <div className="flex items-center justify-between">
                <span className="text-xs font-semibold text-gray-700">
                  {unlockedCount} de {total} desbloqueadas
                </span>
                <span className="text-2xs font-bold text-gray-500">
                  {percent}%
                </span>
              </div>
              <ProgressBar value={percent} variant="primary" size="md" />
            </Card.Body>
          </Card>
        )}
      </Screen.Context>

      <Screen.Content className="pt-2">
        {isLoading && <MedalsSkeleton />}

        {!isLoading && isEmpty && (
          <Card className="shadow-sm">
            <Card.Body className="px-4 py-6 text-center">
              <p className="m-0 text-sm font-bold text-gray-900">
                Nenhuma medalha por aqui ainda
              </p>
              <p className="m-0 mt-1 text-xs text-gray-600">
                Complete jornadas para desbloquear medalhas.
              </p>
            </Card.Body>
          </Card>
        )}

        {!isLoading && !isEmpty && (
          <div className="grid grid-cols-3 gap-3 pb-8">
            {medals.map(medal => (
              <Card key={medal.id} className="shadow-sm">
                <Card.Body className="flex flex-col items-center gap-2 p-3">
                  <div className="w-full">
                    <MedalThumb medal={medal} size="md" />
                  </div>
                  <span
                    className={
                      medal.unlocked
                        ? 'line-clamp-2 text-center text-xs font-bold text-gray-900'
                        : 'line-clamp-2 text-center text-xs font-bold text-gray-500'
                    }
                  >
                    {medal.name}
                  </span>
                </Card.Body>
              </Card>
            ))}
          </div>
        )}
      </Screen.Content>
    </Screen>
  )
}

DigitalProductMedals.pageTitle = 'Medalhas'
